import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './_guards/auth/auth.guard';
import { AuthorizationGuard } from './_guards/authorization/authorization.guard';

import { LoginComponent } from './pages/auth/login/login.component';
import { BlListaComponent } from './pages/bl-lista/bl-lista.component';
import { BlDetalleComponent } from './pages/bl-detalle/bl-detalle.component';
import { PreloadAllModules } from '@angular/router';
import { PedimentoComponent } from './shared/pages/pedimento/pedimento.component';
import { Rule238Component } from './components/rule238/rule238.component';
import { CabotajeLoteCrearComponent } from './cabotage/pages/cabotaje-lote-crear/cabotaje-lote-crear.component';
import { CabotajeLoteMovimientoComponent } from './cabotage/pages/cabotaje-lote-movimiento/cabotaje-lote-movimiento.component';
import { CabotajeLoteEntradaListaComponent } from './cabotage/pages/cabotaje-lote-entrada-lista/cabotaje-lote-entrada-lista.component';
import { CabotajeLoteEntradaComponent } from './cabotage/pages/cabotaje-lote-entrada/cabotaje-lote-entrada.component';
import { CabotajeLoteSalidaListaComponent } from './cabotage/pages/cabotaje-lote-salida-lista/cabotaje-lote-salida-lista.component';
import { CabotajeLoteSalidaComponent } from './cabotage/pages/cabotaje-lote-salida/cabotaje-lote-salida.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'ship-list', component: BlListaComponent, canActivate: [AuthGuard] },
  { path: 'ship-list/:shipId', component: BlDetalleComponent,canActivate: [AuthGuard] },
  { path: 'ship-list/:shipId/cabotage/batch-create/:createId', component: CabotajeLoteCrearComponent, canActivate: [AuthGuard, AuthorizationGuard], data: { path: ['cabotage', 'actions', 'create'] } },
  { path: 'ship-list/:shipId/cabotage/batch-update/:batchId', component: CabotajeLoteCrearComponent, canActivate: [AuthGuard, AuthorizationGuard], data: { path: ['cabotage', 'actions', 'update'] } },
  { path: 'ship-list/:shipId/cabotage/batch-detail/:batchId', component: CabotajeLoteCrearComponent, canActivate: [AuthGuard, AuthorizationGuard], data: { path: ['cabotage', 'actions', 'consult'] } },
  {
    path: 'ship-list/:shipId/cabotage/batch-movement',
    component: CabotajeLoteMovimientoComponent,
    children: [
      { path: 'entry/:batchId', component: CabotajeLoteEntradaComponent, canActivate: [AuthGuard] },
      { path: 'entry-list/:batchId', component: CabotajeLoteEntradaListaComponent, canActivate: [AuthGuard] },
      { path: 'output/:batchId', component: CabotajeLoteSalidaComponent, canActivate: [AuthGuard] },
      { path: 'output-list/:batchId', component: CabotajeLoteSalidaListaComponent, canActivate: [AuthGuard] },
      { path: '**', redirectTo: 'entry/:batchId' },
    ]
  },
  {
    path: 'ship-list/:shipId/exportation/petition',
    component: PedimentoComponent,
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      path: ['export', 'customs', 'consult']
    }
  },
  {
    path: 'ship-list/:shipId/rule238',
    component: Rule238Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'ship-list/:shipId/bill',
    loadChildren: () => import('./billing/billing.module').then(m => m.BillingModule)
  },
  {
    path: 'ship-list/:shipId/importation',
    loadChildren: () => import('./importation/importation.module').then(m => m.ImportationModule),
  },
  {
    path: 'exportation',
    loadChildren: () => import('./exportation/exportation.module').then(m => m.ExportationModule),
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      path: ['export', 'actions', 'consult']
    }
  },
  {
    path: 'cabotage',
    loadChildren: () => import('./cabotage/cabotage.module').then(m => m.CabotageModule),
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      path: ['cabotage', 'actions', 'consult']
    }
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      path: ['reports', 'actions', 'consult']
    }
  },
  {
    path: 'catalogs',
    loadChildren: () => import('./catalogs/catalogs.module').then(m => m.CatalogsModule),
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      path: ['catalog_management', 'actions', 'consult']
    }
  },
  {
    path: 'scale-ticket',
    loadChildren: () => import('./scale-ticket/scale-ticket.module').then(m => m.ScaleTicketModule),
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      path: ['scale_ticket', 'actions', 'consult']
    }
  },
  {
    path: 'appointments',
    loadChildren: () => import('./appointments/appointments.module').then(m => m.AppointmentsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'segurity',
    loadChildren: () => import('./authorizations/authorizations.module').then(m => m.AuthorizationsModule),
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      path: ['authorizations', 'actions', 'consult']
    }
  },
  {
    path: 'notification',
    loadChildren: () => import('./notifications/notifications.module').then(m => m.NotificationsModule),
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      path: ['notifications', 'actions', 'notifications']
    }
  },
  {
    path: 'dec',
    loadChildren: () => import('./dec/dec.module').then(m => m.DecModule),
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      path: ['dec', 'actions', 'consult']
    }
  },
  {
    path: 'chatbot',
    loadChildren: () => import('./chatbot/chatbot.module').then(m => m.ChatbotModule),
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      path: ['chatbot', 'actions', 'consult']
    }
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
  {
    preloadingStrategy: PreloadAllModules
  }
)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
